module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"site-url":"Site do recebedor"},"en-US":{"site-url":"Recipient site"}}')
  delete Component.options._Ctor
}
